import * as React from "react";

import "./selection-tile.scss";

import {makeChain} from "@Common/react/cst2";
import {Types}     from "@Common/types";


export const SelectionTile = ({
    text,
    subText  = "",
    image,
    onClick,
}:{
    text     : string,
    subText ?: string | JSX.Element,
    image    : string,
    onClick  : () => void,
}) => (

    makeChain<JSX.Element>()

    // render the component
    .then(() => (
        <div className="selection-tile-h6t"
            xd-qa-type="card" xd-qa-name={`New Template Selection Tile ${text}`}
            onClick={onClick}
        >
            <div className="image">
                <img src={image}/>
            </div>
            <div className="title" title={text}>
                {text}
                {!!subText && (
                    <div className="sub-text">
                        {subText}
                    </div>
                )}
            </div>
        </div>
    ))

    .run()

);
